// extracted by mini-css-extract-plugin
module.exports = {"reviewtabMinWidth":"415px","img":"VkKMzC","AniFadeIn":"_6vj0xz","AniFadeOut":"HoNlTx","AniRotate":"dUMz4G","AniPlaceholderFadeOut":"DkvUxP"};